import * as Sentry from '@sentry/react';
import React from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

const ChartErrorFallback: React.FC<FallbackProps & { height?: number }> = ({
  resetErrorBoundary,
  height = 220,
}) => (
  <div
    className="flex flex-col items-center justify-center gap-2 rounded-md border border-dashed border-border bg-muted/20 px-4 text-center"
    style={{ minHeight: height }}
    role="alert"
  >
    <p className="text-sm font-medium text-foreground">Unable to render this chart.</p>
    <button
      type="button"
      onClick={resetErrorBoundary}
      className="text-xs font-medium text-primary hover:underline"
    >
      Try again
    </button>
  </div>
);

interface ChartRenderBoundaryProps {
  children: React.ReactNode;
  resetKeys: unknown[];
  height?: number;
}

export const ChartRenderBoundary: React.FC<ChartRenderBoundaryProps> = ({
  children,
  resetKeys,
  height,
}) => (
  <ErrorBoundary
    FallbackComponent={props => <ChartErrorFallback {...props} height={height} />}
    resetKeys={resetKeys}
    onError={(error, errorInfo) => {
      Sentry.captureException(error, {
        contexts: {
          react: {
            componentStack: errorInfo.componentStack,
          },
        },
      });
    }}
  >
    {children}
  </ErrorBoundary>
);
